import { render, staticRenderFns } from "./purchaseReturnsDetails.vue?vue&type=template&id=71c49a59&scoped=true"
import script from "./purchaseReturnsDetails.vue?vue&type=script&lang=js"
export * from "./purchaseReturnsDetails.vue?vue&type=script&lang=js"
import style0 from "./purchaseReturnsDetails.vue?vue&type=style&index=0&id=71c49a59&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c49a59",
  null
  
)

export default component.exports